/**
 * @generated SignedSource<<5b512891704b7282f1fa80d7a954947f>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type Rows_project$data = {
  readonly " $fragmentSpreads": FragmentRefs<"Row_project">;
  readonly " $fragmentType": "Rows_project";
};
export type Rows_project$key = {
  readonly " $data"?: Rows_project$data;
  readonly " $fragmentSpreads": FragmentRefs<"Rows_project">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isConditionalFormattingEnabled"
    }
  ],
  "kind": "Fragment",
  "name": "Rows_project",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "isConditionalFormattingEnabled",
          "variableName": "isConditionalFormattingEnabled"
        }
      ],
      "kind": "FragmentSpread",
      "name": "Row_project"
    }
  ],
  "type": "JiraProject"
};

(node as any).hash = "6529dd7b2cd4ebb69d9c7a29ad22a15d";

export default node;
